import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import { Amplify } from 'aws-amplify';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { AccountSetupProvider } from './contexts/AccountSetupContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { EchoMailProvider } from './contexts/EchoMailContext';
import awsConfig from './lib/awsConfig';

// Apply the stored theme preference (if any) at the earliest opportunity
const storedTheme = localStorage.getItem('theme');
if (storedTheme === 'dark') {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className="app-viewport-shell flex min-h-0 w-full flex-col">
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <AccountSetupProvider>
            <ProfileProvider>
              <EchoMailProvider>
                <App />
              </EchoMailProvider>
            </ProfileProvider>
          </AccountSetupProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  </React.StrictMode>
);
